// extracted by mini-css-extract-plugin
module.exports = {"pt-integral-goods-form":"pt-integral-goods-form-e87d431e715cabf233e67fd67aac2118"};